import { Divider, Grid2 as Grid, Typography } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { CompaniesAutocomplete } from "@shared/components/AutocompleteFields";

export function StoreForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <CompaniesAutocomplete
          name="company"
          label={translate("v1/store_admin.fields.company")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="active"
          label={translate("v1/store_admin.fields.active")}
          defaultChecked={true}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Divider />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Typography style={{ fontSize: 18, color: "primary.main" }}>
          {translate("v1/store_admin.titles.address_information")}
        </Typography>
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="country"
          label={translate("v1/store_admin.fields.country")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="postal_code"
          label={translate("v1/store_admin.fields.postal_code")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="state"
          label={translate("v1/store_admin.fields.state")}
          disabled
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="city"
          label={translate("v1/store_admin.fields.city")}
          disabled
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="neighborhood"
          label={translate("v1/store_admin.fields.neighborhood")}
        />
      </Grid>

      <Grid size={{ xs: 8 }}>
        <Form.Input
          name="street"
          label={translate("v1/store_admin.fields.street")}
        />
      </Grid>

      <Grid size={{ xs: 4 }}>
        <Form.Input
          name="number"
          label={translate("v1/store_admin.fields.number")}
          mask="number"
        />
      </Grid>
    </Grid>
  )
}
